interface ErrorScreenProps {
  email?: string;
}

export function ErrorScreen({ email }: ErrorScreenProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-4">
      <div className="mx-auto w-full max-w-sm">
        <div className="rounded-xl border border-border bg-card p-8 shadow-lg space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="flex size-10 items-center justify-center rounded-full bg-destructive/10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="size-5 text-destructive"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-2 text-center">
            <h2 className="text-base font-semibold">Access not granted</h2>
            <p className="text-sm text-muted-foreground">
              {email ? (
                <span className="font-medium text-foreground">{email}</span>
              ) : (
                'Your account'
              )}{' '}
              is not allowed to access GAIA on this account.
            </p>
          </div>

          {/* Action */}
          <div className="flex justify-center">
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center rounded-lg border border-border bg-background px-4 py-2.5 text-sm font-medium text-foreground shadow-sm transition-colors hover:bg-muted cursor-pointer"
            >
              Try again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
